
import React from 'react';
import { Button } from '@/components/ui/button';
import { BarChart3, LogOut, LayoutDashboard } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';
import { useNavigate, useLocation } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';

interface AdminHeaderProps {
  isMobile: boolean;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ isMobile }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { toast } = useToast();
  const isStatsPage = location.pathname === '/admin-stats';

  const handleSignOut = async () => {
    try {
      await supabase.auth.signOut();
      toast({
        title: "Signed out successfully",
        description: "You have been logged out of your account.",
      });
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
      toast({
        title: "Sign out failed",
        description: "An error occurred while signing out. Please try again.",
        variant: "destructive",
      });
    }
  };
  
  const goToStats = () => {
    navigate('/admin-stats');
  };
  
  const goToAdmin = () => {
    navigate('/admin');
  };
  
  return (
    <div className="flex justify-between items-center mb-6">
      <h1 className="text-2xl md:text-3xl font-bold">Admin Dashboard</h1>
      <div className="flex items-center gap-2">
        {isStatsPage ? (
          <Button 
            variant="outline"
            onClick={goToAdmin}
            className="flex items-center gap-2"
            size={isMobile ? "sm" : "default"}
          >
            <LayoutDashboard size={isMobile ? 14 : 16} />
            {!isMobile && "Admin"}
          </Button>
        ) : (
          <Button 
            variant="outline"
            onClick={goToStats}
            className="flex items-center gap-2"
            size={isMobile ? "sm" : "default"}
          >
            <BarChart3 size={isMobile ? 14 : 16} />
            {!isMobile && "Stats"}
          </Button>
        )}
        <Button 
          variant="outline" 
          onClick={handleSignOut}
          className="flex items-center gap-2"
          size={isMobile ? "sm" : "default"}
        >
          <LogOut size={isMobile ? 14 : 16} />
          {!isMobile && "Sign Out"}
        </Button>
      </div>
    </div>
  );
};

export default AdminHeader;
